import React from 'react';
export function Topbar() {
  return <div className="sticky top-0 z-50 bg-gold px-5 py-2.5 text-center font-semibold tracking-[0.04em] text-[#111] text-[10px]" data-id="element-273">
      🔥 PRECIO DE LANZAMIENTO <span className="mx-3 opacity-70" data-id="element-274">·</span> Acceso
      inmediato al comprar <span className="mx-3 opacity-70" data-id="element-275">·</span> Garantía 7
      días sin preguntas
    </div>;
}